import moment from 'moment';

export default class GuestlistCreateModalController {

    constructor($scope, $injector, $uibModalInstance) {
        this.scope = $scope;
        this.injector = $injector;
        this.modalInstance = $uibModalInstance;
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');
        this.acl = this.injector.get('Acl');
        this.log = this.injector.get('$log');
        this.submitting = false;

        this.isPrivateGuestlist = false;
        this.model = {
            name: '',
            settings: {
                start_date: moment().format('Y-M-D HH:mm'),
                end_date: moment().format('Y-M-D HH:mm'),
                create_ticket: true,
                create_passbook: true,
                create_templates: true,
            },
            permission: 'public'
        };

        this._resetError();
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.model.settings.start_date;
        }, () => {
            if(moment(this.model.settings.end_date, 'Y-M-D HH:mm') < moment(this.model.settings.start_date, 'Y-M-D HH:mm')) {
                this.model.settings.end_date = _.clone(this.model.settings.start_date);
            }
        })
        this.scope.$watch(() => {
            return this.model.settings.end_date;
        }, () => {
            if(moment(this.model.settings.end_date, 'Y-M-D HH:mm') < moment(this.model.settings.start_date, 'Y-M-D HH:mm')) {
                this.model.settings.start_date = _.clone(this.model.settings.end_date);
            }
        })
    }

    dismiss() {
        this.modalInstance.dismiss();
    }

    submit(form) {
        this._resetError();
        if (!form.$valid) {
            this._setError(this.translate.instant('guestlists.modals.create.messages.invalid_data'));
            return;
        }

        this.submitting = true;

        this.api.post('guestlists/create-with-dependencies', this._prepareModelForApi()).then((response) => {
            this.modalInstance.close({
                guestlist: response.data.data
            });
        }, (e) => {
            this._setError(this.translate.instant('guestlists.modals.create.messages.api_error'));
            this.log.error('Error while creating guestlist', e);
            this.submitting = false;
        });
    }

    _resetError() {
        this.error = {
            active: false,
            message: ''
        };
    }

    _setError(message) {
        this.error = {
            active: true,
            message: message
        };
    }

    _prepareModelForApi() {
        const dataForApi = _.cloneDeep(this.model);

        dataForApi.permission = this.isPrivateGuestlist ? 'private' : 'public';
        dataForApi.settings.start_date = moment(dataForApi.settings.start_date, 'Y-M-D HH:mm').format();
        dataForApi.settings.end_date = moment(dataForApi.settings.end_date, 'Y-M-D HH:mm').format();

        return dataForApi;
    }
}

GuestlistCreateModalController.$inject = [
    '$scope',
    '$injector',
    '$uibModalInstance'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/controllers/modals/create-modal-controller.js